import { EXPORT_PX, type PxSize } from "./exportConfig";

export type FrameKey = "basic" | "tabTop" | "tabBottom" | "arrow";

type ComposeInput = {
  frame: FrameKey;
  qrInner: string;          // inner SVG of the QR (no root svg)
  qrViewBox: { w: number; h: number };
  frameColor?: string;
  textColor?: string;
  label?: string;
  bgColor?: string;
};

export type ComposeFramesResult = { inner: string; nativeSize: PxSize };

const D_BOTTOM = `M13.7,346.6h251.7c7.6,0,13.7-6.2,13.7-13.7V13.7c0-7.6-6.2-13.7-13.7-13.7H13.8C6.2,0,0.1,6.2,0,13.7
v319.2C0,340.5,6.2,346.6,13.7,346.6z M10.6,17.9c0-4.1,3.3-7.4,7.4-7.4h243.2c4.1,0,7.4,3.3,7.4,7.4v243.3c0,4.1-3.3,7.4-7.4,7.4
H18c-4.1,0-7.4-3.3-7.4-7.4V17.9z`;

const D_TAB_TOP = `M265.4,122.1H13.7c-7.6,0-13.7,6.2-13.7,13.7v251.7c0,7.6,6.2,13.7,13.7,13.7h251.6
c7.6,0,13.7-6.2,13.8-13.7V135.8C279.1,128.2,272.9,122.1,265.4,122.1z M12.5,0h253.7c6.8,0,12.4,5.5,12.4,12.4v55.7
c0,6.8-5.5,12.4-12.4,12.4h-37.9l-18.8,28.8c-1.2,1.2-3.2,1.2-4.4,0l-18.8-28.8H12.5c-6.8,0-12.4-5.5-12.4-12.4V12.4
C0.1,5.5,5.6,0,12.5,0z M268.5,383.3c0,4.1-3.3,7.4-7.4,7.4H17.9c-4.1,0-7.4-3.3-7.4-7.4V140c0-4.1,3.3-7.4,7.4-7.4h243.2
c4.1,0,7.4,3.3,7.4,7.4V383.3z`;

const D_TAB_BOTTOM = `M13.7,279.1h251.7c7.6,0,13.7-6.2,13.7-13.7V13.7c0-7.6-6.2-13.7-13.7-13.7H13.8C6.2,0,0.1,6.2,0,13.7v251.7
C0,273,6.2,279.1,13.7,279.1z M10.6,17.9c0-4.1,3.3-7.4,7.4-7.4h243.2c4.1,0,7.4,3.3,7.4,7.4v243.3c0,4.1-3.3,7.4-7.4,7.4H18
c-4.1,0-7.4-3.3-7.4-7.4V17.9z M266.2,401.3H12.5c-6.8,0-12.4-5.5-12.4-12.4v-55.7c0-6.8,5.5-12.4,12.4-12.4h94.6
c0.8,0,1.6-0.3,2.2-0.9l27.8-27.8c1.2-1.2,3.2-1.2,4.4,0l27.8,27.8c0.6,0.6,1.4,0.9,2.2,0.9h94.6c6.8,0,12.4,5.5,12.4,12.4v55.7
C278.6,395.7,273,401.3,266.2,401.3z`;

const POINTER_VIEW_W = 528.28;
const POINTER_VIEW_H = 206.213;
const POINTER_PATHS = [
  "M141.885,160.355c11.616,2.761,17.021,8.855,17.021,14.491,0,22.886-40.137,26.565-56.698,26.565-4.485,0-18.516,0-18.516-6.67,0-2.415,4.025-8.511,5.865-10.235,1.38-1.15,8.166-3.335,9.891-3.335.575,0,.92.115.92.805,0,1.15-1.15,1.726-1.955,2.186-.69.46-1.265,1.035-1.955,1.725v.23c41.057,1.495,52.328-10.351,52.328-12.191,0-5.865-31.856-10.465-37.377-11.385-5.75-.92-11.73-2.761-11.73-9.661,0-3.795,1.84-12.19,3.68-15.295,3.565-5.865,24.381-16.791,49.567-16.791,4.83,0,9.661.575,14.491,1.61,2.645.574,2.99,1.494,2.99,3.795,0,8.51-2.875,10.465-9.661,13.11-4.945,1.84-5.865,2.415-10.351,5.636-.805.46-1.955,1.149-2.875,1.149-1.15,0-1.84-.575-1.84-1.725,0-.23,2.185-3.796,8.395-8.051l-.23-.229c-29.671,1.035-42.437,11.73-42.552,14.375,0,1.61-1.495,2.415,30.591,9.891Z",
  "M177.532,178.066c-2.53,1.84-4.6,3.565-4.6,6.785,0,2.646,2.76,6.211,8.741,6.211,8.74,0,18.746-8.051,25.416-13.226l1.38,4.484c-7.015,7.476-19.896,18.861-30.821,18.861-8.855,0-13.111-8.28-13.111-16.791,0-9.66,3.45-13.226,10.926-18.86,5.175-3.91,16.216-10.121,22.656-10.121,3.565,0,5.175,1.84,5.175,5.29,0,6.326-9.085,15.182-12.19,15.182-2.645,0-3.795-2.876-3.91-5.061l-9.661,7.245Z",
  "M224.911,191.867c-2.186,1.725-9.546,7.705-12.191,7.705-3.22,0-9.89-7.59-10.12-13.57-.46-14.376,29.441-29.097,42.782-29.441,5.291-.115,7.476,4.14,7.476,5.521s-2.99,2.529-4.025,2.875c2.185.92,3.335,2.185,3.335,4.715,0,3.681-10.005,11.73-10.005,17.136,0,1.955,1.725,2.761,3.565,2.761,4.83,0,11.385-5.865,16.331-9.201l.92,4.256c-4.945,5.635-20.356,17.94-25.991,17.94-3.795,0-5.52-2.76-5.52-6.095,0-3.681,2.76-9.776,4.255-12.881l-.23-.23-10.58,8.511ZM210.995,188.877c.115.575.575,2.646,2.3,2.3,2.3-.46,5.865-.114,28.636-23.116l-.23-.229c-27.371,8.396-30.707,15.411-30.707,21.046Z",
  "M315.993,176.916l.92,5.061c-6.095,5.405-17.94,19.551-26.336,19.551-4.37,0-6.44-3.68-6.44-7.59,0-6.9,6.211-14.491,9.891-19.781l-.229-.23c-6.671,4.945-12.536,10.926-17.711,17.597-1.726,2.185-5.98,7.82-9.086,7.82-5.06,0-6.325-7.246-6.44-11.156-.345-7.935,6.9-19.551,13.571-25.186,1.495-1.266,2.529-1.38,4.484-1.38,6.9.229,6.326,1.84,6.326,2.529,0,4.485-14.491,16.102-14.491,18.861,0,.69.575,1.265,1.266,1.265.805,0,1.84-1.034,2.3-1.609,9.2-11.73,30.361-25.877,33.696-25.877.46,0,1.15.575,1.84,2.186.69,1.725,1.381,3.795,1.726,6.21,0,4.485-14.146,13.226-14.146,21.161,0,1.035.92,2.07,2.07,2.07,2.76,0,7.82-4.025,9.89-5.75l6.9-5.751Z",
  "M415.812,171.511c10.811-14.146,14.721-20.471,18.631-28.061,1.955-3.681,1.495-4.945.23-4.945-1.38,0-2.76,1.495-3.565,2.415l-27.602,29.901-17.25,23.23c-1.955,2.646-4.831,7.016-8.511,7.016-4.83,0-7.131-9.085-8.396-12.65l24.036-30.361c12.075-21.621,10.006-23.921,8.051-23.921-.92,0-2.646.92-3.565,1.38-35.422,16.561-29.901,16.791-35.767,16.791-1.84,0-3.335-1.495-2.761-4.256,1.15-6.21,2.07-12.535,2.99-13.57,1.035-1.38.346-1.15,10.581-8.396.575-.46,2.07-1.61,2.875-1.61.575,0,1.38.46,1.38,1.15s-1.61,2.76-6.095,6.67l.229.23,12.996-5.98c1.38-.575,17.596-8.28,21.735-8.051,2.761.115,3.221,1.726,4.37,3.681l2.761,4.83c.805,1.495,1.38,2.646,1.38,4.37,0,3.795-5.865,15.756-7.131,20.011l.23.23,18.286-17.711c4.255-4.025,14.03-12.65,18.746-12.766,2.529-.115,8.395,1.955,8.395,7.936,0,8.511-12.42,25.531-17.136,32.776l.23.23c14.146-12.191,27.371-24.727,42.437-36.688,1.495-1.265,3.796-3.68,5.865-3.68,3.105,0,7.936,7.476,7.936,9.891,0,2.3-3.564,6.325-4.945,8.05l-17.825,21.736c-5.291,6.44-13.226,17.366-13.226,26.106,0,2.3,1.265,5.635,4.024,5.635,3.221,0,12.191-5.175,27.717-20.24l.46,4.37c-2.76,7.936-27.486,27.486-37.377,27.486-7.59,0-10.12-7.246-10.12-13.916,0-13.801,14.605-31.052,22.656-41.517l-.23-.23c-19.551,16.561-25.876,21.736-43.932,44.622-1.726,2.186-7.246,8.74-10.121,8.74-4.485,0-6.095-8.28-6.095-11.615,0-3.22,2.76-6.67,4.6-9.085l7.82-10.236Z",
  "M528.28,182.552c-7.016,8.165-19.666,18.976-31.052,18.976-8.396,0-12.306-7.476-12.535-15.065-.46-15.065,16.216-30.477,31.166-30.361,3.681,0,8.28.92,8.28,5.521,0,5.635-5.635,14.146-27.716,21.391l-.23,2.53c-.345,4.37,3.45,5.865,7.131,5.865,8.165,0,17.826-8.396,23.921-13.226l1.035,4.37ZM514.019,164.036c0-.806-.575-1.495-1.38-1.266-5.75,1.495-12.421,7.016-15.525,14.605,10.12-3.45,17.021-11.385,16.905-13.34Z",
  "M81.375,22.779c-1.635,2.633-4.265,2.448-6.718,3.571-5.573,2.551-10.496,7.509-15.201,11.564-5.233,4.51-9.606,8.255-14.056,13.758-.55.681-2.8,4.132-3.215,4.258-1.211.368-1.235-3.91-1.076-4.686.04-.194.364-.188.423-.328,3.079-7.311,7.399-14.051,11.892-20.317.897-1.25,1.704-2.572,2.706-3.735-1.283.645-2.585,1.308-3.837,2.025C26.447,43.696,3.407,72.281,6.851,106.407c3.697,36.629,36.651,53.133,66.538,57.306,1.663.646.967,4.563-.626,4.724-2.185.22-5.427.009-7.687-.12C31.58,166.398,2.21,145.069,0,106.003c-1.605-28.381,13.977-61.725,33.705-79.605,3.69-3.345,7.78-6.16,11.903-8.823l-2.709-.554c-5.468-.731-13.004-1.395-17.993-3.862-.107-.053-.105-.245-.195-.307-.18-.123-.452-.078-.513-.134-.07-.065-.386-1.797-.376-1.969.048-.792.699-2.403,1.363-2.855.799-.543,3.122-1.463,4.12-1.836,12.205-4.56,26.654-3.064,39.012.049,3.663.923,9.019,2.299,12.436,3.775,3.077,1.329,2.359,8.016,1.551,10.738-.196.661-.576,1.593-.928,2.16Z"
];

export function composeFrameSVG(input: ComposeInput): ComposeFramesResult {
  const label = input.label ?? "SCAN ME";
  const frameColor = input.frameColor ?? "#000";
  const textColor = input.textColor ?? "#fff";
  const { w: qrW, h: qrH } = input.qrViewBox;
  // Unify text size across frames to match Bottom label spec
  const BOTTOM_BANNER_H = 346.6 - 279.1; // 67.5
  const UNIFIED_FONT_PX = Math.round(BOTTOM_BANNER_H * 0.52); // ≈ 35

  function fitFontPxByWidth(text: string, maxWidthPx: number, maxPx: number, family = "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif", weight: string | number = 600): number {
    const c = document.createElement("canvas");
    const ctx = c.getContext("2d")!;
    let lo = 8, hi = Math.max(8, Math.floor(maxPx)), best = 8;
    while (lo <= hi) {
      const mid = Math.floor((lo + hi) / 2);
      ctx.font = `${weight} ${mid}px ${family}`;
      const w = ctx.measureText(text).width;
      if (w <= maxWidthPx) { best = mid; lo = mid + 1; } else { hi = mid - 1; }
    }
    return best;
  }

  if (input.frame === "arrow") {
    // Normalize to the same design width as other frames
    const W = 279.1;
    const windowX = 18.0;
    const windowY = 17.9;
    const windowW = 243.2;
    const windowH = 243.3;
    const gap = 17.9; // same gap as bottom frame

    // Banner scaled to ~80% of QR width
    const bannerW = Math.round(windowW * 0.8);
    const scale = bannerW / POINTER_VIEW_W;
    const bannerH = Math.round(POINTER_VIEW_H * scale);
    const H = windowY + windowH + gap + bannerH;

    const s = Math.min(windowW / qrW, windowH / qrH);
    const qx = windowX + (windowW - qrW * s) / 2;
    const qy = windowY + (windowH - qrH * s) / 2;
    const bx = Math.round((W - bannerW) / 2);
    const by = windowY + windowH + gap;

    const bg = `<rect x="${windowX}" y="${windowY}" width="${windowW}" height="${windowH}" fill="${input.bgColor || '#ffffff'}"/>`;
    const qrPlaced = `<g transform="translate(${qx},${qy}) scale(${s})">${input.qrInner}</g>`;
    const paths = POINTER_PATHS.map((d) => `<path d="${d}" fill="${frameColor}"/>`).join("");
    const pointer = `<g transform="translate(${bx},${by}) scale(${scale})">${paths}</g>`;
    const inner = [bg, qrPlaced, pointer].join("\n");
    return { inner, nativeSize: { w: W, h: H } };
  }

  // Speech tabs and basic use fixed design coordinates with a QR window
  if (input.frame === "tabTop" || input.frame === "tabBottom" || input.frame === "basic") {
    const isTop = input.frame === "tabTop";
    const isBasic = input.frame === "basic";
    const designW = 279.1;
    const designH = isBasic ? 346.6 : 401.3;
    const pathD = isBasic ? D_BOTTOM : (isTop ? D_TAB_TOP : D_TAB_BOTTOM);
    // QR window from originals
    const qx = isTop ? 17.9 : 18.0;
    const qy = isTop ? 140.0 : 17.9;
    const qw = 243.2;
    const qh = 243.3;

    const s = Math.min(qw / qrW, qh / qrH);
    const qcx = qx + (qw - qrW * s) / 2;
    const qcy = qy + (qh - qrH * s) / 2;
    const bg = `<rect x="${qx}" y="${qy}" width="${qw}" height="${qh}" fill="${input.bgColor || '#ffffff'}"/>`;
    const qrPlaced = `<g transform="translate(${qcx},${qcy}) scale(${s})">${input.qrInner}</g>`;

    let labelText = "";
    if (!isBasic) {
      const bannerTop = isTop ? 0 : 279.1;
      const bannerBottom = isTop ? 122.1 : designH;
      const bannerH = bannerBottom - bannerTop;
      // Match original canvas tuning for visual centering around pointer notch
      const vAdjust = isTop ? -bannerH * 0.18 : bannerH * 0.18;
      const yCenter = (bannerTop + bannerBottom) / 2 + vAdjust;
      const labelMaxWidth = qw * 0.92;
      const maxPx = Math.floor(bannerH * 0.52);
      const fontPx = fitFontPxByWidth(label, labelMaxWidth, maxPx);
      const baselineAdjust = Math.round(fontPx * 0.30);
      const y = yCenter + baselineAdjust + (isTop ? -Math.round(fontPx * 0.02) : 0);
      labelText = `<text x="${designW / 2}" y="${y}" fill="${textColor}" font-family="Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif" font-weight="600" font-size="${fontPx}" text-anchor="middle" dominant-baseline="alphabetic">${label}</text>`;
    } else {
      const bannerTop = qy + qh;
      const bannerBottom = designH;
      const bannerH = bannerBottom - bannerTop;
      const yCenter = (bannerTop + bannerBottom) / 2;
      const labelMaxWidth = (designW - 36) * 0.92;
      const maxPx = Math.floor(bannerH * 0.55);
      const fontPx = fitFontPxByWidth(label, labelMaxWidth, maxPx);
      const baselineAdjust = Math.round(fontPx * 0.30);
      const y = yCenter + baselineAdjust;
      labelText = `<text x="${designW / 2}" y="${y}" fill="${textColor}" font-family="Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif" font-weight="600" font-size="${fontPx}" text-anchor="middle" dominant-baseline="alphabetic">${label}</text>`;
    }

    const frame = `<path d="${pathD}" fill="${frameColor}"/>`;
    const inner = [frame, bg, qrPlaced, labelText].join("\n");
    return { inner, nativeSize: { w: designW, h: designH } };
  }

  // Fallback, should not happen
  return { inner: input.qrInner, nativeSize: EXPORT_PX.square };
}


